import * as libphonenumber from 'google-libphonenumber';

export enum PhoneNumberType {
  MOBILE = libphonenumber.PhoneNumberType.MOBILE,
  FIXED = libphonenumber.PhoneNumberType.FIXED_LINE,
  ALL = libphonenumber.PhoneNumberType.FIXED_LINE_OR_MOBILE
}

export class CountryPhone {
  iso: string;
  name: string;
  code: string;
  sample_phone: string;

  constructor (iso: string, name: string, sampleMode: PhoneNumberType = PhoneNumberType.MOBILE) {
    this.iso = iso;
    this.name = name;

    const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
    const PNF = libphonenumber.PhoneNumberFormat;
    let PNT: libphonenumber.PhoneNumberType = null;
    switch (sampleMode) {
      case PhoneNumberType.MOBILE:
        PNT = libphonenumber.PhoneNumberType.MOBILE;
        break;
      case PhoneNumberType.FIXED:
        PNT = libphonenumber.PhoneNumberType.FIXED_LINE;
        break;
      case PhoneNumberType.ALL:
        PNT = libphonenumber.PhoneNumberType.FIXED_LINE_OR_MOBILE;
        break;
    }
    const country_example_number = phoneUtil.getExampleNumberForType(this.iso, PNT);
      // We need to define what kind of country phone number type we are going to use as a mask.
      // You can choose between many types including:
      //    - FIXED_LINE
      //    - MOBILE
    // tslint:disable-next-line:max-line-length
      //    - For more types please refer to google libphonenumber repo
      // tslint:disable-next-line:max-line-length
    //    (https://github.com/googlei18n/libphonenumber/blob/f9e9424769964ce1970c6ed2bd60b25b976dfe6f/javascript/i18n/phonenumbers/phonenumberutil.js#L913)
    const example_number_formatted = phoneUtil.format(country_example_number, PNF.NATIONAL);
      // We need to define how are we going to format the phone number
      // You can choose between many formats including:
      //    - NATIONAL
      //    - INTERNATIONAL
      //    - E164
      //    - RFC3966

    this.sample_phone = example_number_formatted;
    this.code = '+' + country_example_number.getCountryCode();

    // console.log(this.iso,  this.sample_phone, this.code);
  }
}
